export type HospitalAccessRole = "grandmaster" | "master" | "hospital";

export type SwitcherAccount = {
  id: string;
  name: string;
  parentId?: string | null;
  inHierarchy?: boolean;
};

/** Master = in hospital_master and a direct child of the organisation/root. */
export function isMasterAccount(
  hospital: SwitcherAccount,
  rootId?: string | null,
  all: SwitcherAccount[] = [],
): boolean {
  if (!hospital?.id || !rootId || hospital.id === rootId) return false;
  const parentId = hospital.parentId || null;
  if (parentId && parentId !== rootId) return false;
  if (hospital.inHierarchy === true) return true;
  return all.some((child) => child.parentId === hospital.id);
}

export function accountRoleLabel(
  hospital: SwitcherAccount | null | undefined,
  accessRole: HospitalAccessRole,
  rootId?: string | null,
  all: SwitcherAccount[] = [],
): "Grandmaster" | "Master" | "Hospital" {
  if (!hospital?.id) return "Hospital";
  if (accessRole === "grandmaster" && hospital.id === rootId) return "Grandmaster";
  if (accessRole === "master" && hospital.id === rootId) return "Master";
  if (isMasterAccount(hospital, rootId, all)) return "Master";
  return "Hospital";
}
